<template>
  <unauth-base-card :tip="tip">
    <template v-slot:top>
      <back-button />
    </template>

    <v-card-text>
      <div v-if="loading" class="d-flex justify-center mb-4">
        <v-progress-circular color="primary" indeterminate size="64" />
      </div>
      <div v-else>
        <reset-password-form
          ref="form"
          :user="user"
          :loading="formLoading"
          @submit="submit"
        />
        <v-row>
          <v-col class="text-center">
            <v-btn
              large
              class="elevation-0 unauth-action-btn unauth-submit-btn"
              @click="submit"
              :loading="formLoading"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </unauth-base-card>
</template>

<script>
import BackButton from '@/components/unauth/BackButton';
import UnauthBaseCard from '@/components/unauth/UnauthBaseCard';
import ResetPasswordForm from '@/components/admin/controls/users/forms/password/ResetPasswordForm';


export default {
  components: {
    BackButton,
    UnauthBaseCard,
    ResetPasswordForm,
  },
  data: () => ({
    loading: true,
    formLoading: false,
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    tip() {
      return this.loading ?
        'Verifying your token...' :
        'Please enter your new password';
    },
    token() {
      return this.$route.query.t;
    },
  },
  methods: {
    submit() {
      const formRef = this.$refs.form;
      if (!formRef.validate()) { return; }

      this.formLoading = true;
      const model = formRef.getModel();
      const data = {
        token: this.token,
        password: model.new_password,
        confirm_password: model.confirm_new_password,
      };

      this.$requests.post('/auth/reset-password/', data)
        .then(response => {
          this.$toast.success(response.data.message, { timeout: 3000 });
          this.$router.push({ name: 'LoginView' });
        })
        .catch(err => {
          this.$toast.error(err.response.data.message, { timeout: 3000 });
        })
        .then(() => {
          this.formLoading = false;
        });
    },
    checkToken() {
      const config = { params: { t: this.token } };
      this.$requests.get('auth/check-reset-pass-token/', config)
        .then(() => {
          this.loading = false;
        })
        .catch(err => {
          this.$toast.error(err.response.data.message, { timeout: 5000 });
          const viewName = err.response.status === 400 ? 'ForgotPasswordView' : 'LoginView';
          this.$router.push({ name: viewName });
        });
    },
  },
  mounted() {
    this.checkToken();
  },
};
</script>
